export const arabicLocalization = {
    af: 'أفغانستان', // Afghanistan
    al: 'ألبانيا', // Albania
    dz: 'الجزائر', // Algeria
    as: 'ساموا الأمريكية', // American Samoa
    ad: 'أندورا', // Andorra
    ao: 'أنغولا', // Angola
    ai: 'أنغويلا', // Anguilla
    aq: 'القارة القطبية الجنوبية', // Antarctica
    ag: 'أنتيغوا وبربودا', // Antigua and Barbuda
    ar: 'الأرجنتين', // Argentina
    am: 'أرمينيا', // Armenia
    aw: 'أروبا', // Aruba
    au: 'أستراليا', // Australia
    at: 'النمسا', // Austria
    az: 'أذربيجان', // Azerbaijan
    bs: 'جزر البهاما', // Bahamas
    bh: 'البحرين', // Bahrain
    bd: 'بنغلاديش', // Bangladesh
    bb: 'بربادوس', // Barbados
    by: 'بيلاروسيا', // Belarus
    be: 'بلجيكا', // Belgium
    bz: 'بليز', // Belize
    bj: 'بنين', // Benin
    bm: 'برمودا', // Bermuda
    bt: 'بوتان', // Bhutan
    bo: 'بوليفيا', // Bolivia
    ba: 'البوسنة والهرسك', // Bosnia and Herzegovina
    bw: 'بوتسوانا', // Botswana
    br: 'البرازيل', // Brazil
    io: 'إقليم المحيط الهندي البريطاني', // British Indian Ocean Territory
    vg: 'جزر العذراء البريطانية', // British Virgin Islands
    bn: 'بروناي', // Brunei
    bg: 'بلغاريا', // Bulgaria
    bf: 'بوركينا فاسو', // Burkina Faso
    bi: 'بوروندي', // Burundi
    kh: 'كمبوديا', // Cambodia
    cm: 'الكاميرون', // Cameroon
    ca: 'كندا', // Canada
    cv: 'الرأس الأخضر', // Cape Verde
    bq: 'الجزر الكاريبية الهولندية', // Caribbean Netherlands
    ky: 'جزر كايمان', // Cayman Islands
    cf: 'جمهورية أفريقيا الوسطى', // Central African Republic
    td: 'تشاد', // Chad
    cl: 'تشيلي', // Chile
    cn: 'الصين', // China
    cx: 'جزيرة الكريسماس', // Christmas Island
    cc: 'جزر كوكوس (كيلينغ)', // Cocos (Keeling) Islands
    co: 'كولومبيا', // Colombia
    km: 'جزر القمر', // Comoros
    cd: 'جمهورية الكونغو الديمقراطية', // Congo (DRC)
    cg: 'جمهورية الكونغو', // Congo (Republic)
    ck: 'جزر كوك', // Cook Islands
    cr: 'كوستاريكا', // Costa Rica
    ci: 'ساحل العاج', // Côte d’Ivoire
    hr: 'كرواتيا', // Croatia
    cu: 'كوبا', // Cuba
    cw: 'كوراساو', // Curaçao
    cy: 'قبرص', // Cyprus
    cz: 'جمهورية التشيك', // Czech Republic
    dk: 'الدنمارك', // Denmark
    dj: 'جيبوتي', // Djibouti
    dm: 'دومينيكا', // Dominica
    do: 'جمهورية الدومينيكان', // Dominican Republic
    ec: 'الإكوادور', // Ecuador
    eg: 'مصر', // Egypt
    sv: 'السلفادور', // El Salvador
    gq: 'غينيا الاستوائية', // Equatorial Guinea
    er: 'إريتريا', // Eritrea
    ee: 'إستونيا', // Estonia
    sz: 'إسواتيني', // Eswatini
    et: 'إثيوبيا', // Ethiopia
    fk: 'جزر فوكلاند', // Falkland Islands (Islas Malvinas)
    fo: 'جزر فارو', // Faroe Islands
    fj: 'فيجي', // Fiji
    fi: 'فنلندا', // Finland
    fr: 'فرنسا', // France
    gf: 'غويانا الفرنسية', // French Guiana
    pf: 'بولينيزيا الفرنسية', // French Polynesia
    ga: 'الغابون', // Gabon
    gm: 'غامبيا', // Gambia
    ge: 'جورجيا', // Georgia
    de: 'ألمانيا', // Germany
    gh: 'غانا', // Ghana
    gi: 'جبل طارق', // Gibraltar
    gr: 'اليونان', // Greece
    gl: 'جرينلاند', // Greenland
    gd: 'غرينادا', // Grenada
    gp: 'غوادلوب', // Guadeloupe
    gu: 'غوام', // Guam
    gt: 'غواتيمالا', // Guatemala
    gg: 'غيرنسي', // Guernsey
    gn: 'غينيا', // Guinea
    gw: 'غينيا بيساو', // Guinea-Bissau
    gy: 'غيانا', // Guyana
    ht: 'هايتي', // Haiti
    hn: 'هندوراس', // Honduras
    hk: 'هونغ كونغ', // Hong Kong
    hu: 'المجر', // Hungary
    is: 'آيسلندا', // Iceland
    in: 'الهند', // India
    id: 'إندونيسيا', // Indonesia
    ir: 'إيران', // Iran
    iq: 'العراق', // Iraq
    ie: 'أيرلندا', // Ireland
    im: 'جزيرة مان', // Isle of Man
    il: 'إسرائيل', // Israel
    it: 'إيطاليا', // Italy
    jm: 'جامايكا', // Jamaica
    jp: 'اليابان', // Japan
    je: 'جيرسي', // Jersey
    jo: 'الأردن', // Jordan
    kz: 'كازاخستان', // Kazakhstan
    ke: 'كينيا', // Kenya
    ki: 'كيريباتي', // Kiribati
    kw: 'الكويت', // Kuwait
    xk: 'كوسوفو',
    kg: 'قيرغيزستان', // Kyrgyzstan
    la: 'لاوس', // Laos
    lv: 'لاتفيا', // Latvia
    lb: 'لبنان', // Lebanon
    ls: 'ليسوتو', // Lesotho
    lr: 'ليبيريا', // Liberia
    ly: 'ليبيا', // Libya
    li: 'ليختنشتاين', // Liechtenstein
    lt: 'ليتوانيا', // Lithuania
    lu: 'لوكسمبورغ', // Luxembourg
    mo: 'ماكاو', // Macau
    mg: 'مدغشقر', // Madagascar
    mw: 'مالاوي', // Malawi
    my: 'ماليزيا', // Malaysia
    mv: 'جزر المالديف', // Maldives
    ml: 'مالي', // Mali
    mt: 'مالطا', // Malta
    mh: 'جزر مارشال', // Marshall Islands
    mq: 'مارتينيك', // Martinique
    mr: 'موريتانيا', // Mauritania
    mu: 'موريشيوس', // Mauritius
    yt: 'مايوت', // Mayotte
    mx: 'المكسيك', // Mexico
    fm: 'ولايات ميكرونيسيا المتحدة', // Micronesia
    md: 'مولدوفا', // Moldova
    mc: 'موناكو', // Monaco
    mn: 'منغوليا', // Mongolia
    me: 'الجبل الأسود', // Montenegro
    ms: 'مونتسرات', // Montserrat
    ma: 'المغرب', // Morocco
    mz: 'موزمبيق', // Mozambique
    mm: 'ميانمار (بورما)', // Myanmar (Burma)
    na: 'ناميبيا', // Namibia
    nr: 'ناورو', // Nauru
    np: 'نيبال', // Nepal
    nl: 'هولندا', // Netherlands
    nc: 'كاليدونيا الجديدة', // New Caledonia
    nz: 'نيوزيلندا', // New Zealand
    ni: 'نيكاراغوا', // Nicaragua
    ne: 'النيجر', // Niger
    ng: 'نيجيريا', // Nigeria
    nu: 'نيوي', // Niue
    nf: 'جزيرة نورفولك', // Norfolk Island
    kp: 'كوريا الشمالية', // North Korea
    mk: 'مقدونيا الشمالية', // North Macedonia
    mp: 'جزر ماريانا الشمالية', // Northern Mariana Islands
    no: 'النرويج', // Norway
    om: 'عُمان', // Oman
    pk: 'باكستان', // Pakistan
    pw: 'بالاو', // Palau
    ps: 'فلسطين', // Palestine
    pa: 'بنما', // Panama
    pg: 'بابوا غينيا الجديدة', // Papua New Guinea
    py: 'باراغواي', // Paraguay
    pe: 'بيرو', // Peru
    ph: 'الفلبين', // Philippines
    pl: 'بولندا', // Poland
    pt: 'البرتغال', // Portugal
    pr: 'بورتوريكو', // Puerto Rico
    qa: 'قطر', // Qatar
    re: 'ريونيون', // Réunion
    ro: 'رومانيا', // Romania
    ru: 'روسيا', // Russia
    rw: 'رواندا', // Rwanda
    ws: 'ساموا', // Samoa
    sm: 'سان مارينو', // San Marino
    st: 'ساو تومي وبرينسيب', // São Tomé & Príncipe
    sa: 'المملكة العربية السعودية', // Saudi Arabia
    sn: 'السنغال', // Senegal
    rs: 'صربيا', // Serbia
    sc: 'سيشيل', // Seychelles
    sl: 'سيراليون', // Sierra Leone
    sg: 'سنغافورة', // Singapore
    sx: 'سينت مارتن', // Sint Maarten
    sk: 'سلوفاكيا', // Slovakia
    si: 'سلوفينيا', // Slovenia
    sb: 'جزر سليمان', // Solomon Islands
    so: 'الصومال', // Somalia
    za: 'جنوب أفريقيا', // South Africa
    kr: 'كوريا الجنوبية', // South Korea
    ss: 'جنوب السودان', // South Sudan
    es: 'إسبانيا', // Spain
    lk: 'سريلانكا', // Sri Lanka
    bl: 'سان بارتيليمي', // St. Barthélemy
    sh: 'سانت هيلينا', // St. Helena
    kn: 'سانت كيتس ونيفيس', // St. Kitts & Nevis
    lc: 'سانت لوسيا', // St. Lucia
    mf: 'سان مارتن', // St. Martin
    pm: 'سان بيير وميكلون', // St. Pierre & Miquelon
    vc: 'سانت فنسنت والجرينادين', // St. Vincent & Grenadines
    sd: 'السودان', // Sudan
    sr: 'سورينام', // Suriname
    sj: 'سفالبارد وجان ماين', // Svalbard & Jan Mayen
    se: 'السويد', // Sweden
    ch: 'سويسرا', // Switzerland
    sy: 'سوريا', // Syria
    tw: 'تايوان', // Taiwan
    tj: 'طاجيكستان', // Tajikistan
    tz: 'تنزانيا', // Tanzania
    th: 'تايلاند', // Thailand
    tl: 'تيمور الشرقية', // Timor-Leste
    tg: 'توغو', // Togo
    tk: 'توكيلاو', // Tokelau
    to: 'تونغا', // Tonga
    tt: 'ترينيداد وتوباغو', // Trinidad & Tobago
    tn: 'تونس', // Tunisia
    tr: 'تركيا', // Turkey
    tm: 'تركمانستان', // Turkmenistan
    tc: 'جزر توركس وكايكوس', // Turks & Caicos Islands
    tv: 'توفالو', // Tuvalu
    ug: 'أوغندا', // Uganda
    ua: 'أوكرانيا', // Ukraine
    ae: 'الإمارات العربية المتحدة', // United Arab Emirates
    gb: 'المملكة المتحدة', // United Kingdom
    us: 'الولايات المتحدة', // United States
    uy: 'أوروغواي', // Uruguay
    vi: 'جزر العذراء الأمريكية', // U.S. Virgin Islands
    uz: 'أوزبكستان', // Uzbekistan
    vu: 'فانواتو', // Vanuatu
    va: 'الفاتيكان', // Vatican City
    ve: 'فنزويلا', // Venezuela
    vn: 'فيتنام', // Vietnam
    wf: 'واليس وفوتونا', // Wallis & Futuna
    eh: 'الصحراء الغربية', // Western Sahara
    ye: 'اليمن', // Yemen
    zm: 'زامبيا', // Zambia
    zw: 'زيمبابوي', // Zimbabwe
    ax: 'جزر أولاند', // Åland Islands
  };